<template>

    <div class="loader" v-if="loading">
        <img src="/images/loader.svg" alt="Загрузка...">
    </div>

</template>


<script>

    export default {
        computed: {
            loading () {
                return this.$store.state.loading > 0
            }
        },
    }

</script>
